import styled from 'styled-components';

const FooterActions = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  bottom: 0.5rem;
  right: 0;
`;

export default { FooterActions };
